export const organismos = [
    {
        "nombre": "Comisión de Agua y Alcantarillado de Sistemas Intermunicipales",
        "icon":"icon-water",
        "url" : "http://caasim.hidalgo.gob.mx/",
        "alias" : "CAASIM"
    },
    {
        "nombre": "Comisión de Agua y Alcantarillado del Sistema Valle del Mezquital",
        "icon":"icon-water",
        "url" : "http://caasvam.hidalgo.gob.mx/",
        "alias" : "CAASVAM"
    },
    {
        "nombre": "Comisión Estatal del Agua y Alcantarillado",
        "icon":"icon-water",
        "url" : "http://ceaa.hidalgo.gob.mx/",
        "alias" : "CEAA"
    },
    {
        "nombre": "Centro Estatal de Maquinaria para el Desarrollo",
        "icon":"icon-excavator",
        "url" : "http://maquinaria.hidalgo.gob.mx/",
        "alias" : "CEMD"
    },
    {
        "nombre": "Comisión Estatal de Vivienda",
        "icon":"icon-home-filled-d",
        "url" : "http://cevi.hidalgo.gob.mx/",
        "alias" : "CEVI"
    },
]